import styled from 'styled-components';

export const Container = styled.div`
  padding-bottom: 5rem;
`;

export const H6b = styled.h6`
  font-weight: bold;
`;

export const H6 = styled.h6``;

export const ButtonDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 2rem;
  flex-wrap: wrap;

  @media screen and (max-width: ${({ theme }) => theme.size?.medium}) {
    flex-direction: column;
    align-items: stretch;

    & > * {
      width: 100% !important;
    }
  }
`;
